import Swiper, { EffectCreative, Navigation } from "swiper";
import gsap from "gsap";

document.addEventListener('DOMContentLoaded', () => {
  const productSlider = document.querySelector('.product-slider')
  const productSwiper = productSlider?.querySelector('.product-slider__swiper')
  const navigation = productSlider?.querySelector('.product-slider__navigation')
  const productSlides = productSlider?.querySelectorAll('.product-slider__slide > video')
  const steps = productSlider?.querySelectorAll('.product-step')
  const accordions = document.querySelectorAll('.product-accordions .accordion')
  const productMapText = document.querySelector('.product-map__text')
  const productMapButton = document.querySelector('.product-map__all-text')
  const productSteps = document.querySelector('.product-slider__steps')
  if (productSlider && productSwiper && navigation && productSlides.length) {
    let activeIndex = 0
    let timeLine = gsap.timeline()
    const progressbar = productSlider.querySelector('.product-controllers__progressbar span')
    const play = productSlider.querySelector('.product-controllers__play')
    const fullScreen = productSlider.querySelector('.product-controllers__fullscreen')
    const swiper = new Swiper(productSwiper, {
      modules: [Navigation, EffectCreative],
      speed: 1000,
      navigation: {
        nextEl: '.product-slider__navigation .slider-navigation__button--next',
        prevEl: '.product-slider__navigation .slider-navigation__button--prev'
      },
      creativeEffect: {
        prev: {
          translate: ["-20%", 0, -1],
        },
        next: {
          translate: ["100%", 0, 0],
        },
      },
    })

    let timeout

    const timeOut = (time) => {
      clearTimeout()
      timeout = setTimeout(() => {
        swiper.slideNext()
      }, time)
    }

    const stopAndPlay = () => {
      if (productSlides[activeIndex].paused) {
        productSlides[activeIndex].play()
        const circle = steps[activeIndex].querySelector('circle')
        timeLine.pause()
        timeLine = gsap.timeline()
        const time = productSlides[activeIndex].currentTime
        const fullTime = productSlides[activeIndex].duration ? productSlides[activeIndex].duration : 16
        timeLine.to(progressbar, { width: `100%`, delay: 0, duration: fullTime - time, ease: 'none' })
        timeLine.to(circle, { strokeDashoffset: 59, delay: 0, duration: fullTime - time, ease: 'none' }, '<')
        timeOut(timeLine.duration() * 1000)
      } else {
        clearTimeout(timeout)
        productSlides[activeIndex].pause()
        timeLine.pause()
      }
    }

    let debounce

    const videoStart = () => {
      if (!productSlides[activeIndex]?.duration) {
        clearTimeout(debounce)
        debounce = setTimeout(() => {
          videoStart()
        }, 100)
        return;
      }
      let time = productSlides[activeIndex].currentTime
      if (!productSlides[activeIndex]) return
      const fullTime = productSlides[activeIndex].duration
      const circle = steps[activeIndex].querySelector('circle')
      if (Math.ceil(fullTime) === Math.ceil(time)) {
        time = 0
        productSlides[activeIndex].currentTime = 0
        timeLine.to(circle, { strokeDashoffset: 360, delay: 0, duration: 0, ease: 'none' }, '<')
      }

      const width = 100 / fullTime * time
      timeLine.to(progressbar, { width: `${width}%`, delay: 0, duration: 0 })

      timeout = setTimeout(() => {
        steps[activeIndex].classList.add('product-step--active')
        productSlides[activeIndex].play()
        timeLine.to(progressbar, { width: `100%`, delay: 0, duration: fullTime - time, ease: 'none' })
        timeLine.to(circle, { strokeDashoffset: 59, delay: 0, duration: fullTime - time, ease: 'none' }, '<')
        timeOut(timeLine.duration() * 1000)
      }, 1000)
    }

    const moveStep = () => {
      const left = steps[activeIndex].offsetLeft - (window.innerWidth - productSteps.closest('.container').clientWidth) / 2
      productSteps.scrollTo({ left, behavior: 'smooth' })
    }

    swiper.on('slideChange', () => {
      clearTimeout(timeout)
      if (!productSlides[activeIndex]) return
      productSlides[activeIndex].pause()
      steps[activeIndex].classList.remove('product-step--active')
      timeLine.pause()
      timeLine = gsap.timeline()
      timeLine.to(progressbar, { width: 0, delay: 0, duration: 0 })
      activeIndex = swiper.realIndex
      videoStart()
      moveStep()
    })

    const checkSound = productSlider.querySelector('.product-slider-sound__input')

    if (checkSound) {
      const changeMuted = () => {
        productSlides.forEach(slide => {
          slide.muted = !checkSound.checked
        })
      }

      checkSound.addEventListener('change', changeMuted)
      changeMuted()
    }

    const resize = () => {
      moveStep()
    }

    resize()
    window.addEventListener('resize', resize)


    productSlides.forEach(video => video.addEventListener('click', stopAndPlay))
    let animate = false
    const startAnimate = () => {
      if (animate) return
      animate = true
      videoStart()

    }
    window.addEventListener('scroll', () => {
      if (window.scrollY > productSlider.offsetTop + productSlider.clientHeight) return
      if (window.scrollY >= productSlider.offsetTop - productSlider.clientHeight / 2) {
        startAnimate()
      }
    })
    play.addEventListener('click', stopAndPlay)


    const fullScreenOpen = (element) => {
      element.requestFullscreen();
      productSwiper.classList.add('product-slider__swiper--open')
    }

    const fullScreenCancel = (key = null) => {
      if (key) document.exitFullscreen();

      productSwiper.classList.remove('product-slider__swiper--open')
    }

    document.addEventListener('fullscreenchange', () => {
      if (window.innerHeight !== screen.height) {
        fullScreenCancel()
      }
    });
    fullScreen.addEventListener('click', () => {
      if (productSwiper.classList.contains('product-slider__swiper--open')) {
        fullScreenCancel(true)
        return
      }
      fullScreenOpen(productSwiper)
    })

    steps.forEach((step, index) => {
      const image = step.querySelector('.product-step__image')
      if (image) {
        image.addEventListener('click', () => {
          swiper.slideTo(index)
        })
      }
    })
  }

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.closest('.video__wrapper')?.querySelector('.video__start')?.click()
        }, 500)
        observer.unobserve(entry.target)
      }
    })
  }, { threshold: 0.5 })

  if (accordions.length) {
    let activeIndex = 0

    const accordionClick = (take = null) => {
      if (take) {
        accordions[activeIndex].querySelector('video').pause()
      }
      accordions[activeIndex].querySelector('.accordion__head')?.click()

    }
    accordionClick()


    accordions.forEach((accordion, index) => {
      if (index === 0) {
        const video = accordion.querySelector('video')
        observer.observe(video)
      }

      accordion.querySelector('.accordion__head')?.addEventListener('click', () => {
        if (activeIndex === index) {
          activeIndex = null
          return
        }
        if (activeIndex !== null) accordionClick(true)
        activeIndex = index
        setTimeout(() => {
          const coord = accordions[activeIndex].getBoundingClientRect()
          window.scrollTo({top: coord.top + window.scrollY - 56, behavior: 'smooth'})
          accordions[activeIndex].querySelector('.video__start').click()
        }, 500)
      })
    })
  }

  if (productMapText && productMapButton) {
    const delay = 0
    const duration = .3

    const allText = document.querySelector('.product-map__text').childNodes
    const paragraphsList = []
    let firstIndex = null
    const productMapTextChange = (item, index) => {
      let tegName = item.tagName
      if(tegName === 'br' || !tegName) {
        paragraphsList.push(document.createElement('br'))
        return;
      }
      if(firstIndex === null && tegName !=='br') {
        firstIndex = index
      }
      tegName = tegName.toLowerCase()
      if(tegName === 'div') {
        item.childNodes.forEach(childItem => {
          productMapTextChange(childItem)
        })
        return;
      }
      const images = item.querySelectorAll('img')
      if(images.length) {
        images.forEach(image => {
          paragraphsList.push(image)
        })
        return;
      }
      if(tegName === 'p') {
        const paragraph = document.createElement('p')
        paragraph.innerHTML = item.innerHTML
        paragraphsList.push(paragraph)
        return;
      }
      if(tegName === 'h2') {
        item.classList.add('title')
        item.classList.add(`title--h4`)
      }
      if(tegName === 'h3') {
        item.classList.add('title')
        item.classList.add(`title--h5`)
      }
      if(tegName === 'h4') {
        item.classList.add('title')
        item.classList.add(`title--h6`)
      }
      paragraphsList.push(item)
    }

    allText.forEach((textItem, index) => {
      productMapTextChange(textItem, index)
    })
    productMapText.innerHTML = ''
    paragraphsList.forEach(item => {
      productMapText.appendChild(item)
    })
    const closeText = () => {
      gsap.to(productMapText, { height: paragraphsList[firstIndex].clientHeight + firstIndex * 32, duration, delay })
      const showMoreText = productMapButton.querySelector('#show-more')
      const showLessText = productMapButton.querySelector('#show-less')
      if(showMoreText && showLessText) {
        
        showMoreText.style.display = 'block'
        showLessText.style.display = 'none'
      }
      setTimeout(() => {
        productMapText.classList.remove('product-map__text--view')
      }, 300)
    }

    const resize = () => {
      if(window.innerWidth < 780) {
        closeText()
        return
      }
      productMapText.style.height =  'auto'
    }
    resize()
    window.addEventListener('resize', resize)

    const openText = () => {
      productMapText.classList.add('product-map__text--view')
      gsap.to(productMapText, { height: 'auto', duration, delay })
      const showMoreText = productMapButton.querySelector('#show-more')
      const showLessText = productMapButton.querySelector('#show-less')
      showLessText.style.display = 'block'
      showMoreText.style.display = 'none'
    }

    productMapButton.addEventListener('click', () => {
      if (productMapText.classList.contains('product-map__text--view')) {
        closeText()
        return
      }
      openText()
    })

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 780) {
        productMapText.classList.remove('product-map__text--view')
        gsap.to(productMapText, { height: 'auto', duration: 0, delay })
      }
    })
  }

})